import React from "react";

const FAILURE_MESSAGE = "Recommendation disclaimers could not be loaded";

const Disclaimers = (props) => {
    let content;
    if (props.disclaimers === null) {
        content = <div className="x-disclaimer"><em><small>Loading...</small></em></div>;
    } else {
        let messages = props.disclaimers.errors.length > 0 ? [FAILURE_MESSAGE].concat(props.disclaimers.errors) : props.disclaimers.success;
        content = messages.map((disclaimer, idx) =>
            <div key={idx} className="x-disclaimer"><small>{disclaimer}</small></div>
        );
    }

    return (
        <div>
            <h5>Disclaimer</h5>
            { content }
        </div>
    );
};
Disclaimers.propTypes = {
    disclaimers: React.PropTypes.shape({
        success: React.PropTypes.arrayOf(React.PropTypes.string),
        errors: React.PropTypes.arrayOf(React.PropTypes.string)
    })
};
Disclaimers.defaultProps = {
    disclaimers: null
};

export default Disclaimers;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/Disclaimers.js
 **/